import script from "./BulletPointList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BulletPointList.vue?vue&type=script&setup=true&lang=ts"

import "./BulletPointList.vue?vue&type=style&index=0&id=1e094ca3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e094ca3"]])

export default __exports__